<template>
  <header>
    <div class="inputs">
      <base-input-text
        v-model="startDate"
        type="date"
        label='Início'
      />
      <base-input-text
        v-model="endDate"
        type="date"
        label='Final'
      />
      <base-button
        @click="handleChangeItems"
        :disabled="!isValid()"
      >
        Pesquisar
      </base-button>
    </div>
  </header>
</template>

<script>

export default {
  name: 'HeaderApiKey',
  props: { },
  data(){
    return {
      startDate: '',
      endDate: ''
    }
  },
  methods: {
    isValid(){
      if(!this.startDate || !this.endDate) {
        return false
      }

      return true
    },
    async handleChangeItems(){
      const params =  {
        startDate: new Date(this.startDate).toISOString().split('T')[0],
        endDate: new Date(this.endDate).toISOString().split('T')[0],
      }

      this.$emit('change-api-key', params)
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  button{
    height: 48px;
  }
  .inputs {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-wrap: wrap;
    span {
      font-weight: bold;
    }
  }
}
</style>
